import { Routes } from '@angular/router';
import { OrientacoesTecnicasContent } from './orientacoes-tecnicas-content';
import { OrientacoesRelatoriosContent } from '@/features/solicitacoes/orientacoes-tecnicas/relatorios/orientacoes-relatorios-content';
import { ComposeEmailOrientacoesComponent } from '@/features/solicitacoes/orientacoes-tecnicas/dashboard-orientacoes-tecnicas/components/dialogs/compose-email-orientacoes/compose-email-orientacoes';
import { DashboardOrientacoesTecnicas } from '@/features/solicitacoes/orientacoes-tecnicas/dashboard-orientacoes-tecnicas/dashboardOrientacoesTecnicas';
import { OrientacoesTecnicasDetalhe } from '@/features/solicitacoes/orientacoes-tecnicas/dashboard-orientacoes-tecnicas/components/orientacoes-tecnicas-detalhe/orientacoes-tecnicas-detalhe';

const rootPath = 'orientacoes';

export const orientacoesTecnicasRoutes: Routes = [
    {
        path: rootPath,
        component: OrientacoesTecnicasContent,
        children: [
            { path: '', component: DashboardOrientacoesTecnicas },
            { path: 'dashboard', component: DashboardOrientacoesTecnicas },
            { path: 'detalhe', component: OrientacoesTecnicasDetalhe },
            { path: 'relatorios', component: OrientacoesRelatoriosContent },
            { path: 'email', component: ComposeEmailOrientacoesComponent }
        ]
    }
];
